import React from 'react';
import Medications from '../../../views/corp/medications/Medications';

const medicationsRoutes = [
  {
    path: '/corp/medications',
    element: <Medications />
  }
];

export default medicationsRoutes;
